import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { s as styles } from '../../anchor-panel-0570bfc1.js';
import '../../style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class FilterDropdownElement extends PureComponent {
  render() {
    const { label } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: styles.AnchorPanel_FilterDropdownElement }, label);
  }
}
__publicField(FilterDropdownElement, "propTypes", {
  label: PropTypes.string
});

export { FilterDropdownElement as default };
//# sourceMappingURL=FilterDropdownElement.js.map
